// @flow
import ContactForm from 'components/contact/ContactForm';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchThemes } from 'actions/faqActions';
import type { formInputsType } from 'types/ContactForm';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/contact/ContactForm';
import { postContactForm, fetchContactForm, fetchAllContactForm } from 'actions/formActions';

export default withRouter(connect(
  (state: StateType): StateProps => ({
    themes: state.faqState.themes,
    contactForm: state.formState.contactForm,
    fetchStatus: state.formState.fetchStatus,
    sendStatus: state.formState.sendStatus,
    contactFormList: state.formState.contactFormList,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchThemes: () => dispatch(fetchThemes()),
    postContactForm: (formInputs: formInputsType, id: number) => dispatch(postContactForm(formInputs, id)),
    fetchContactForm: () => dispatch(fetchContactForm()),
    fetchAllContactForm: () => dispatch(fetchAllContactForm()),
  })
)(ContactForm));
